export const MERIDIAN_OPTIONS = [
  { label: 'AM', value: 'am' },
  { label: 'PM', value: 'pm' },
];
